import { render, staticRenderFns } from "./DescripcionDespachoModalComponent.vue?vue&type=template&id=3ccf9dad&"
import script from "./DescripcionDespachoModalComponent.vue?vue&type=script&lang=js&"
export * from "./DescripcionDespachoModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports